module.exports = __webpack_public_path__ + "img/arsenal-logo-icon.098b5e84.png";